// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_mobileTourNav__drV5S {
  position: fixed;
  top: 100px;
  right: 16px;
  width: auto;
  min-width: 180px;
  background: var(--color-white, #ffffff);
  border-radius: 8px;
  border: 1px solid var(--color-gray-strokes, #e5e7eb);
  box-shadow: 0 12px 16px -4px rgba(127, 127, 127, 0.08), 0 4px 6px -2px rgba(127, 127, 127, 0.03);
  padding: 8px;
  z-index: 9999;
  animation: styles_slideDown__f4ufL 0.2s ease-out;
}

.styles_navLabel__Yu0TC {
  font-size: 11px;
  color: #6b7280;
  padding: 4px 8px 8px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 4px;
}

.styles_navItems__IhDex {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.styles_navItem__rqzqL {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  min-height: 44px;
  width: 100%;
  text-align: left;
  transition: background-color 0.15s ease;
}
.styles_navItem__rqzqL:hover {
  background: #f8fafc;
}
.styles_navItem__rqzqL:active {
  background: #f1f5f9;
}
.styles_navItem__rqzqL.styles_active__iC1bg {
  background: #eff6ff;
}

.styles_navIcon__6J58u {
  width: 20px;
  height: 20px;
  color: #64748b;
  flex-shrink: 0;
}
.styles_active__iC1bg .styles_navIcon__6J58u {
  color: #3b82f6;
}

.styles_navText__s3X\\+R {
  font-size: 14px;
  font-weight: 400;
  color: var(--color-black, #1f2937);
}
.styles_active__iC1bg .styles_navText__s3X\\+R {
  color: #3b82f6;
  font-weight: 500;
}

@keyframes styles_slideDown__f4ufL {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/mobile-tour-nav/styles.module.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,oDAAA;EACA,gGAAA;EAEA,YAAA;EACA,aAAA;EACA,gDAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gCAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,uCAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,mBAAA;AAFJ;AAKE;EACE,mBAAA;AAHJ;;AAOA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAJF;AAME;EACE,cAAA;AAJJ;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;AALF;AAOE;EACE,cAAA;EACA,gBAAA;AALJ;;AASA;EACE;IACE,4BAAA;IACA,UAAA;EANF;EAQA;IACE,wBAAA;IACA,UAAA;EANF;AACF","sourcesContent":["@import \"mixins\";\n.mobileTourNav {\n  position: fixed;\n  top: 100px;\n  right: 16px;\n  width: auto;\n  min-width: 180px;\n  background: var(--color-white, #ffffff);\n  border-radius: 8px;\n  border: 1px solid var(--color-gray-strokes, #e5e7eb);\n  box-shadow: 0 12px 16px -4px rgba(127, 127, 127, 0.08),\n    0 4px 6px -2px rgba(127, 127, 127, 0.03);\n  padding: 8px;\n  z-index: 9999;\n  animation: slideDown 0.2s ease-out;\n}\n\n.navLabel {\n  font-size: 11px;\n  color: #6b7280;\n  padding: 4px 8px 8px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 1px solid #f1f5f9;\n  margin-bottom: 4px;\n}\n\n.navItems {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.navItem {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  min-height: 44px;\n  width: 100%;\n  text-align: left;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background: #f8fafc;\n  }\n\n  &:active {\n    background: #f1f5f9;\n  }\n\n  &.active {\n    background: #eff6ff;\n  }\n}\n\n.navIcon {\n  width: 20px;\n  height: 20px;\n  color: #64748b;\n  flex-shrink: 0;\n\n  .active & {\n    color: #3b82f6;\n  }\n}\n\n.navText {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--color-black, #1f2937);\n\n  .active & {\n    color: #3b82f6;\n    font-weight: 500;\n  }\n}\n\n@keyframes slideDown {\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileTourNav": `styles_mobileTourNav__drV5S`,
	"slideDown": `styles_slideDown__f4ufL`,
	"navLabel": `styles_navLabel__Yu0TC`,
	"navItems": `styles_navItems__IhDex`,
	"navItem": `styles_navItem__rqzqL`,
	"active": `styles_active__iC1bg`,
	"navIcon": `styles_navIcon__6J58u`,
	"navText": `styles_navText__s3X+R`
};
export default ___CSS_LOADER_EXPORT___;
